import React, { Component } from 'react'

import { isLatAmCountry } from 'shared/tools/country-helpers'
import './bestsellers-header.styl'

type Props = {
  userCountry: string
}

const COVERS_URL = {
  dk:
    'https://a.bmstatic.com/iu/149/237/dk-new-22764172cbd87edbbcff7099cdd72a52.png',
  kz:
    'https://a.bmstatic.com/iu/126/246/Covers_KK-d0a1dcfaa512c8a4afe0304303e5e8fe.png',
  es:
    'https://a.bmstatic.com/iu/188/214/es-new-546eb9dbad4f24c0c0b37cbe9178d403.png',
  ru:
    'https://a.bmstatic.com/iu/225/205/Covers_RU-b770045db2b9fa94f2bd9527104e813a.png',
  rs:
    'https://a.bmstatic.com/iu/253/95/Covers_SR-eeaccf3db637f30f49f850679a24a13e.png',
  gb:
    'https://a.bmstatic.com/iu/100/43/en-574356ac8b559658205f7e94f7fa70a7.png',
  ua:
    'https://a.bmstatic.com/iu/52/128/Covers_UKR-72dce666bb6383e62abe9c1ab604d9d1.png',
  us:
    'https://a.bmstatic.com/iu/100/43/en-574356ac8b559658205f7e94f7fa70a7.png',
  mx:
    'https://a.bmstatic.com/iu/188/214/es-new-546eb9dbad4f24c0c0b37cbe9178d403.png',
  co:
    'https://a.bmstatic.com/iu/188/214/es-new-546eb9dbad4f24c0c0b37cbe9178d403.png',
  cl:
    'https://a.bmstatic.com/iu/188/214/es-new-546eb9dbad4f24c0c0b37cbe9178d403.png',
  ar:
    'https://a.bmstatic.com/iu/188/214/es-new-546eb9dbad4f24c0c0b37cbe9178d403.png',
}

export class BestsellersHeader extends Component<Props> {
  getCoverPerRegion(country: string): string {
    return COVERS_URL[country]
      ? COVERS_URL[country]
      : isLatAmCountry(country)
      ? COVERS_URL.es
      : COVERS_URL.gb
  }

  render(): JSX.Element {
    const { userCountry } = this.props
    const localeBestsellersCover = this.getCoverPerRegion(userCountry)

    return (
      <div
        className="header-bestsellers__wrapper"
        style={{
          background: `url(${localeBestsellersCover}) no-repeat center / contain`,
        }}
      />
    )
  }
}
